module.exports = __webpack_public_path__ + "static/media/add-secondary-tenant.421b4435.svg";